import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex w-full gap-2 lg:gap-5" }
const _hoisted_2 = { class: "flex items-center w-48 rounded-lg border px-5 py-4 border-gray-200 dark:border-gray-700" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "grid lg:grid-cols-2 gap-2 lg:gap-5 w-full" }

import { pb } from "@/pocketbase";
import Title from "@/components/Title.vue";
import LinkBox from "@/components/LinkBox.vue";
import Heading from "@/components/Heading.vue";
import Divider from "@/components/Divider.vue";
import Content from "@/components/Content.vue";
import { Product } from "@/model";


export default /*@__PURE__*/_defineComponent({
  __name: 'BusinessUnitsView',
  async setup(__props) {

let __temp: any, __restore: any

const products: Product[] = (
  ([__temp,__restore] = _withAsyncContext(() => pb.collection('products').getFullList<Product>(null, {
  expand: 'businessUnit',
  sort: 'businessUnit.name,name',
  '$autoCancel': false,
}))),
  __temp = await __temp,
  __restore(),
  __temp
);

const productsByBusinessUnit: {
  [index: string]: {
    id: string,
    name: string,
    logo: string,
    products: {
      id: string;
      name: string,
      description: string,
    }[],
  }
} = {};

for (const product of products) {
  if (!productsByBusinessUnit[product.businessUnit]) {
    productsByBusinessUnit[product.businessUnit] = {
      id: product.businessUnit,
      name: product.expand!.businessUnit!.name,
      logo: product.expand!.businessUnit!.logo,
      products: [],
    };
  }
  productsByBusinessUnit[product.businessUnit].products.push({
    id: product.id,
    name: product.name,
    description: product.description,
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Title, { subtitle: "and their products" }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("Business Units")
      ])),
      _: 1,
      __: [0]
    }),
    _createVNode(Divider),
    _createVNode(Content, null, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(productsByBusinessUnit, (businessUnit) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            _createVNode(Heading, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(businessUnit.name), 1)
              ]),
              _: 2
            }, 1024),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                  class: "w-full object-contain",
                  src: _unref(pb).files.getUrl({
            id:businessUnit.id,
            collectionName: 'business_units',
          }, businessUnit.logo),
                  alt: `Logo of ${businessUnit.name}`
                }, null, 8, _hoisted_3)
              ]),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(businessUnit.products, (product) => {
                  return (_openBlock(), _createBlock(LinkBox, {
                    route: "product",
                    "route-params": { id: product.id },
                    title: product.name,
                    description: product.description || 'No description available yet'
                  }, null, 8, ["route-params", "title", "description"]))
                }), 256))
              ])
            ])
          ], 64))
        }), 64))
      ]),
      _: 1
    })
  ], 64))
}
}

})